import moment from 'moment';
import { apiRoutes } from '../config-data/apiRoutes';


export const LOAD_NEWS = 'LOAD_NEWS';

export async function loadNews() {
	let apiResponse = await fetch(apiRoutes.NEWS);
	let responseData = await apiResponse.json();
	
	_mapDateToMoment(responseData);

	return {
		type: LOAD_NEWS,
		payload: {
			newsData: responseData
		}
	};
}


function _mapDateToMoment(news) {
	for (let singleNews of news) {
		singleNews.date = moment(singleNews.date).format('DD.MM.YYYY');
	}
}



// WEBPACK FOOTER //
// ./src/actions/news.actions.js